import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CalculateIcon from '@mui/icons-material/Calculate';
import { formatCurrency } from '../../utils/formatters';

const SectionHeader = ({ title }) => (
  <Box display="flex" alignItems="center" mb={2}>
    <CalculateIcon color="primary" sx={{ mr: 1 }} />
    <Typography variant="h6">{title}</Typography>
  </Box>
);

const FinancialRow = ({ label, valueBRL, valueUSD }) => (
  <TableRow>
    <TableCell component="th" scope="row">
      {label}
    </TableCell>
    <TableCell align="right">{formatCurrency(valueBRL, 'BRL')}</TableCell>
    {valueUSD !== undefined ? (
      <TableCell align="right">{formatCurrency(valueUSD, 'USD')}</TableCell>
    ) : (
      <TableCell align="right">-</TableCell>
    )}
  </TableRow>
);

/**
 * ExitTaxesSection - Displays exit/output taxes for Encomenda orders
 * @param {Object} props - Component props
 * @param {Object} props.order - Order data with latest_tax_calculation
 */
const ExitTaxesSection = ({ order }) => {
  if (!order) return null;

  const taxCalculation = order.latest_tax_calculation || {};
  const exchangeRate = taxCalculation.exchange_rate_dollar_to_real || 1;

  const toUSD = (brlValue) => {
    if (brlValue === null || brlValue === undefined) return undefined;
    return brlValue / exchangeRate;
  };

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <SectionHeader title="EXIT TAXES" />
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Tax Type</TableCell>
                <TableCell align="right">BRL</TableCell>
                <TableCell align="right">USD</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <FinancialRow
                label="PIS Exit"
                valueBRL={taxCalculation.pis_saida_brl}
                valueUSD={toUSD(taxCalculation.pis_saida_brl)}
              />
              <FinancialRow
                label="COFINS Exit"
                valueBRL={taxCalculation.cofins_saida_brl}
                valueUSD={toUSD(taxCalculation.cofins_saida_brl)}
              />
              <FinancialRow
                label="IPI Exit"
                valueBRL={taxCalculation.ipi_saida_destaque_brl}
                valueUSD={toUSD(taxCalculation.ipi_saida_destaque_brl)}
              />
              <FinancialRow
                label="ICMS NF Highlight"
                valueBRL={taxCalculation.icms_nf_destaque_brl}
                valueUSD={toUSD(taxCalculation.icms_nf_destaque_brl)}
              />
              <FinancialRow
                label="ICMS Due"
                valueBRL={taxCalculation.icms_recolher_brl}
                valueUSD={toUSD(taxCalculation.icms_recolher_brl)}
              />
              <FinancialRow
                label="Deemed Credit"
                valueBRL={taxCalculation.credito_presumido_brl}
                valueUSD={toUSD(taxCalculation.credito_presumido_brl)}
              />
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default ExitTaxesSection;
